import React from 'react';
export function Guarantee() {
  return <section className="py-10 px-5 bg-cream" data-id="element-74">
      <div className="bg-white border-2 border-sage p-6 text-center" data-id="element-75">
        <h2 className="text-xl font-heading font-bold text-petrol mb-2" data-id="element-76">
          IL TUO INVESTIMENTO È COMPLETAMENTE PROTETTO
        </h2>
        <h3 className="text-lg font-subheading font-bold text-sage mb-4" data-id="element-77">
          🛡️ Garanzia Totale di 7 Giorni
        </h3>

        <div className="text-sm text-graphite space-y-3" data-id="element-78">
          <p data-id="element-79">Il tuo acquisto è completamente protetto.</p>
          <p data-id="element-80">
            Hai 7 giorni interi per esplorare il sistema, consultare i moduli,
            utilizzare le risorse e valutare il materiale.
          </p>
          <p data-id="element-81">
            Se non sarai completamente soddisfatto, ti rimborseremo il 100%
            dell'importo pagato.
          </p>
          <p className="font-bold text-petrol" data-id="element-82">Nessun rischio.</p>
        </div>
      </div>
    </section>;
}